import { createContext, useState, useContext, useEffect } from "react";
import { json } from "react-router-dom";

const Context = createContext();


export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')) || false);


    const refreshUser = async () => {
        try {
            // burayı kendi endpointine göre güncelle
            const res = await fetch("/api/me", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
                },
            });

            if (!res.ok) return;

            const fresh = await res.json();
            setUser(fresh);
        } catch (e) {
            console.log(e);
        }
    };
    const data = {
        user,
        setUser,
        refreshUser
    }
    useEffect(() => {
        localStorage.setItem('user', JSON.stringify(user))
    }, [user])
    return (
        <Context.Provider value={data}>
            {children}
        </Context.Provider>
    )
}
export const useAuth = () => useContext(Context)